export enum RookieDistrictState {
  NOTSET = "NOTSET",
  HOLD = "HOLD",
  ACTIVE = "ACTIVE"
}
